import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Client } from '../../../core/api-client';
import { API_GET_ALL_DOCUMENT_TYPE_LIST, API_DELETE_DOCUMENT_TYPE, API_CREATE_DOCUMENT_TYPE, API_UPDATE_DOCUMENT_TYPE } from '../../../shared/routes/private.routes';
import { DocumentType } from '../../../shared/types/common';

interface DocumentTypeState {
  documentTypeList: DocumentType[];
  loadingDocumentType: boolean;
  error: string | null;
  pagination: {
    page: number;
    limit: number;
    total: number;
  };
}

const initialState: DocumentTypeState = {
  documentTypeList: [],
  loadingDocumentType: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
};

export const getDocumentTypeList = createAsyncThunk(
  'documentType/getDocumentTypeList',
  async ({ params, body }: { params: any; body: any }, { rejectWithValue }) => {
    try {
      const response = await Client.post(API_GET_ALL_DOCUMENT_TYPE_LIST, body, { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createDocumentType = createAsyncThunk(
  'documentType/createDocumentType',
  async (documentTypeData: any, { rejectWithValue }) => {
    try {
      const response = await Client.post(API_CREATE_DOCUMENT_TYPE, documentTypeData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDocumentType = createAsyncThunk(
  'documentType/updateDocumentType',
  async ({ id, body }: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await Client.put(API_UPDATE_DOCUMENT_TYPE + id, body);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteDocumentType = createAsyncThunk(
  'documentType/deleteDocumentType',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Client.delete(API_DELETE_DOCUMENT_TYPE + id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentTypeList.pending, (state) => { state.loadingDocumentType = true; state.error = null; })
      .addCase(getDocumentTypeList.fulfilled, (state, action) => { state.loadingDocumentType = false; state.documentTypeList = action.payload.data; state.pagination = action.payload.pagination; })
      .addCase(getDocumentTypeList.rejected, (state, action) => { state.loadingDocumentType = false; state.error = action.payload as string; })
      .addCase(createDocumentType.pending, (state) => { state.loadingDocumentType = true; state.error = null; })
      .addCase(createDocumentType.fulfilled, (state) => { state.loadingDocumentType = false; state.error = null; })
      .addCase(createDocumentType.rejected, (state, action) => { state.loadingDocumentType = false; state.error = action.payload as string; })
      .addCase(updateDocumentType.pending, (state) => { state.loadingDocumentType = true; state.error = null; })
      .addCase(updateDocumentType.fulfilled, (state) => { state.loadingDocumentType = false; state.error = null; })
      .addCase(updateDocumentType.rejected, (state, action) => { state.loadingDocumentType = false; state.error = action.payload as string; })
      .addCase(deleteDocumentType.pending, (state) => { state.loadingDocumentType = true; state.error = null; })
      .addCase(deleteDocumentType.fulfilled, (state) => { state.loadingDocumentType = false; state.error = null; })
      .addCase(deleteDocumentType.rejected, (state, action) => { state.loadingDocumentType = false; state.error = action.payload as string; });
  },
});

export default documentTypeSlice.reducer;
